import { c as _c } from "react/compiler-runtime";
import type { IconProps } from '../types';
import { getIconColor } from '../utils/get-icon-color';
const IcoAndroid24 = t0 => {
  const $ = _c(8);
  const {
    "aria-label": ariaLabel,
    className,
    color
  } = t0;
  let t1;
  if ($[0] !== color) {
    t1 = getIconColor(color);
    $[0] = color;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const iconColor = t1;
  let t2;
  if ($[2] !== iconColor) {
    t2 = <path d="M10.0077 5.34462C9.97331 5.35087 9.9379 5.35712 9.9077 5.37795C9.78585 5.46022 9.75877 5.63102 9.84104 5.75287L10.4159 6.61101C9.52757 7.08174 8.86522 7.86386 8.64964 8.8022H16.0147C15.7991 7.86386 15.1368 7.08174 14.2484 6.61101L14.8233 5.75287C14.9056 5.63102 14.8785 5.46022 14.7566 5.37795C14.6337 5.29568 14.464 5.33109 14.3817 5.45293L13.7485 6.38606C13.309 6.22568 12.8321 6.13612 12.3322 6.13612C11.8323 6.13612 11.3553 6.22568 10.9158 6.38606L10.2826 5.45293C10.2212 5.36129 10.1097 5.32484 10.0077 5.34462ZM10.8658 7.46916C11.0866 7.46916 11.2657 7.64829 11.2657 7.86907C11.2657 8.0909 11.0866 8.26898 10.8658 8.26898C10.644 8.26898 10.4659 8.0909 10.4659 7.86907C10.4659 7.64829 10.644 7.46916 10.8658 7.46916ZM13.7985 7.46916C14.0203 7.46916 14.1984 7.64829 14.1984 7.86907C14.1984 8.0909 14.0203 8.26898 13.7985 8.26898C13.5777 8.26898 13.3986 8.0909 13.3986 7.86907C13.3986 7.64829 13.5777 7.46916 13.7985 7.46916ZM7.79982 9.33542C7.35825 9.33542 7 9.69367 7 10.1352V13.8678C7 14.3093 7.35825 14.6676 7.79982 14.6676C7.89355 14.6676 7.98312 14.6478 8.06643 14.6176V9.38541C7.98312 9.3552 7.89355 9.33542 7.79982 9.33542ZM8.59965 9.33542V15.2008C8.59965 15.6413 8.95895 16.0006 9.39947 16.0006H15.2649C15.7054 16.0006 16.0647 15.6413 16.0647 15.2008V9.33542H8.59965ZM16.8645 9.33542C16.7708 9.33542 16.6812 9.3552 16.5979 9.38541V14.6176C16.6812 14.6468 16.7708 14.6676 16.8645 14.6676C17.3061 14.6676 17.6643 14.3093 17.6643 13.8678V10.1352C17.6643 9.69367 17.3061 9.33542 16.8645 9.33542ZM9.66608 16.5338V17.6003C9.66608 18.1887 10.1441 18.6667 10.7325 18.6667C11.3209 18.6667 11.7989 18.1887 11.7989 17.6003V16.5338H9.66608ZM12.8654 16.5338V17.6003C12.8654 18.1887 13.3434 18.6667 13.9318 18.6667C14.5202 18.6667 14.9982 18.1887 14.9982 17.6003V16.5338H12.8654Z" fill={iconColor} />;
    $[2] = iconColor;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== ariaLabel || $[5] !== className || $[6] !== t2) {
    t3 = <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label={ariaLabel} className={className} role="img" data-colored={false}>{t2}</svg>;
    $[4] = ariaLabel;
    $[5] = className;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
};
export default IcoAndroid24;